import type { TFunction } from "i18next";
import {
  PRODUCT_IMAGE_MAX_BYTES,
  PRODUCT_IMAGE_MAX_MB,
} from "@dashboard/modules/products/constants/product-image.constants";

export function partitionProductImageFilesBySize(files: File[]): {
  accepted: File[];
  rejectedCount: number;
} {
  const accepted: File[] = [];
  let rejectedCount = 0;
  for (const f of files) {
    if (f.size <= PRODUCT_IMAGE_MAX_BYTES) {
      accepted.push(f);
    } else {
      rejectedCount += 1;
    }
  }
  return { accepted, rejectedCount };
}

export function productImageSizeErrorMessage(
  t: TFunction,
  scope: "admin" | "category" = "admin"
): string {
  if (scope === "category") {
    return t("categories.form.detail.validateErrorSize", {
      size: PRODUCT_IMAGE_MAX_MB,
    });
  }
  return t("admin.products.side.photos.validateErrorSize", {
    size: PRODUCT_IMAGE_MAX_MB,
  });
}
